import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Textarea,
} from "@chakra-ui/react";
import { FieldErrors, UseFormRegister } from "react-hook-form";

const DescriptionInput = ({
  errors,
  register,
}: {
  errors: FieldErrors<any>;
  register: UseFormRegister<any>;
}) => {
  return (
    <FormControl isInvalid={errors?.description && true}>
      <FormLabel>Description</FormLabel>
      <Textarea
        id="description"
        placeholder="description"
        rows={5}
        {...register("description", {
          required: "This is required",
          minLength: {
            value: 10,
            message: "Minimum length should be 10",
          },
        })}
      />
      <FormErrorMessage>
        {errors.description?.message?.toString()}
      </FormErrorMessage>
    </FormControl>
  );
};

export default DescriptionInput;
